export class HTML5Storage {
    setItem(key, value) {
        localStorage.setItem(key, value);
        return Promise.resolve();
    }
    getItem(key) {
        const value = localStorage.getItem(key);
        return Promise.resolve(value);
    }
    removeItem(key) {
        localStorage.removeItem(key);
        return Promise.resolve();
    }
}
class JSONStorage {
    constructor(storage) {
        this.storage = storage;
    }
    getItem(key) {
        return this.storage.getItem(key).then((value) => {
            try {
                return JSON.parse(value);
            }
            catch (e) {
                // do nothing
            }
            return null;
        });
    }
    setItem(key, value) {
        return this.storage.setItem(key, JSON.stringify(value));
    }
    removeItem(key) {
        return this.storage.removeItem(key);
    }
}
export const html5JSONStorage = new JSONStorage(new HTML5Storage());
